import React from 'react';
import PropTypes from 'prop-types';
import HubCardList from './HubCardList';
import CodeOfConduct from './CodeOfConduct';
import MeetingDetails from './MeetingDetails';
import CounselorInfo from './CounselorInfo';
import RehabilitationPlanDetails from './RehabilitationPlanDetails';

const CaseProgressDescription = ({
  step,
  showHubCards = false,
  attributes = {},
  showStep7UpdatedUi,
}) => {
  const stateList = attributes?.externalStatus?.stateList || [];
  const isInitialEvaluationStepCodeOfConductCompleted =
    attributes?.isInitialEvaluationStepCodeOfConductCompleted;

  const hubCards = showHubCards ? (
    <div className="vads-u-clear--both">
      <HubCardList step={step} stateList={stateList} />
    </div>
  ) : null;

  switch (step) {
    case 1: {
      return (
        <>
          <p>
            We received your application for VR&E benefits. If we need more
            information while we review your application, we’ll contact you.
          </p>
          <p>
            We encourage you to learn more about the VR&E program by checking
            out the resources we’ve included on this page.
          </p>
          {hubCards}
        </>
      );
    }

    case 2: {
      return (
        <>
          <p>
            We’re reviewing your application to confirm that you’re eligible to
            receive VR&E benefits and services.
          </p>
          <p>
            In the meantime, learn more about the VR&E program by reviewing the
            additional resources on this page.
          </p>
          {hubCards}
        </>
      );
    }

    case 3: {
      return (
        <>
          <p>
            We’re assigning a counselor to you. Once assigned, your counselor
            will schedule your initial evaluation meeting. Your VA regional
            office may contact you to schedule an orientation. It’s important to
            respond quickly to any VA communications.
          </p>
          <p>
            While you wait, you can continue learning more by exploring the
            resources on this page.
          </p>
          {hubCards}
        </>
      );
    }

    case 4: {
      return (
        <>
          {isInitialEvaluationStepCodeOfConductCompleted ? (
            <MeetingDetails hubCards={hubCards} />
          ) : (
            <CodeOfConduct />
          )}
        </>
      );
    }

    case 5: {
      return (
        <>
          <p>
            Your counselor is completing your entitlement determination review.
          </p>
          <p>
            While you wait, you can continue learning more by exploring the
            resources on this page.
          </p>

          <CounselorInfo />

          {hubCards}
        </>
      );
    }

    case 6: {
      return (
        <>
          <p>
            Your counselor is helping you move through the required next steps
            for creating your VR&E Chapter 31 rehabilitation plan or selecting
            the appropriate career track.
          </p>
          <p>
            Your counselor will provide guidance and outline the specific steps
            to be taken.
          </p>

          <CounselorInfo />
          {hubCards}
        </>
      );
    }

    case 7: {
      if (showStep7UpdatedUi) {
        return (
          <RehabilitationPlanDetails
            attributes={attributes}
            showHubCards={showHubCards}
          />
        );
      }

      return (
        <>
          <p>
            We’ve activated your Chapter 31 rehabilitation plan. If you have
            questions about your rehabilitation plan, contact your counselor.
          </p>

          <CounselorInfo />

          {hubCards}
        </>
      );
    }

    default:
      return null;
  }
};

CaseProgressDescription.propTypes = {
  step: PropTypes.number.isRequired,
  attributes: PropTypes.object,
  showHubCards: PropTypes.bool,
  showStep7UpdatedUi: PropTypes.bool,
};

export default CaseProgressDescription;
